import { HttpErrorResponse, HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { Store } from '@ngxs/store';
import { catchError, Observable, switchMap } from 'rxjs';

import { AuthService } from '@app/core/auth/services/auth.service';
import { AuthStateActions } from '@app/core/auth/store/auth.state.actions';

import { ApiException } from '../api.exception';
import { API_SKIP_REFRESH_TOKEN_INTERCEPTOR_HEADER } from '../tokens/api-skip-refresh-token-interceptor.header';

export function apiRefreshTokenInterceptor(
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> {
  const authService = inject(AuthService);
  const store = inject(Store);

  if (req.headers.has(API_SKIP_REFRESH_TOKEN_INTERCEPTOR_HEADER)) {
    const headers = req.headers.delete(API_SKIP_REFRESH_TOKEN_INTERCEPTOR_HEADER);

    return next(req.clone({ headers }));
  }

  return next(req).pipe(
    catchError((error) => {
      const shouldRefresh =
        (error instanceof ApiException && error.code === 'Unauthorized') ||
        (error instanceof HttpErrorResponse && error.status === 401);

      if (shouldRefresh && authService.refreshToken) {
        return authService.refresh().pipe(
          switchMap((response) => {
            if (response) {
              return next(
                req.clone({
                  setHeaders: {
                    Authorization: `Bearer ${response.accessToken}`,
                    [API_SKIP_REFRESH_TOKEN_INTERCEPTOR_HEADER]: 'true',
                  },
                }),
              ).pipe(
                catchError((error) => {
                  if (
                    (error instanceof ApiException && error.code === 'Unauthorized') ||
                    (error instanceof HttpErrorResponse && error.status === 401)
                  ) {
                    store.dispatch(new AuthStateActions.Clear());
                    window.location.reload();
                  }

                  console.error(error);
                  throw error;
                }),
              );
            } else {
              throw error;
            }
          }),
        );
      }

      throw error;
    }),
  );
}
